/** 更新音色名称时，后端在名称重复时返回的 reason */
export const VOICE_NAME_EXISTS_REASON = 'VoiceNameExists';

export function isVoiceNameExistsError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'reason' in error &&
    (error as { reason?: string }).reason === VOICE_NAME_EXISTS_REASON
  );
}
